import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('CardGrid'),
  isCardGroupType: true,
  props: {
    prefixCls: {
      type: String,
      default: 'ux-card-advance'
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls;
    return h("div", {
      "class": "".concat(prefixCls, "-grid")
    }, [$slots.default]);
  }
};